import { Routes } from '@angular/router';

export const logsRoutes: Routes = [
  {
    path: 'catchment-work-data-logs',
    loadComponent: () =>
      import(
        './catchment-work-data-logs/components/dt-catchment-work-data-logs/dt-catchment-work-data-logs.component'
      ).then((m) => m.DtCatchmentWorkDataLogsComponent),
  },
  {
    path: 'catchment-work-logs-lora-downlink-get-pending-data',
    loadComponent: () =>
      import(
        './catchment-work-logs-lora-downlink-get-pending-data/components/dt-catchment-work-logs-lora-downlink-get-pending-data/dt-catchment-work-logs-lora-downlink-get-pending-data.component'
      ).then((m) => m.DtCatchmentWorkLogsLoraDownlinkGetPendingDataComponent),
  },
  {
    path: 'downlink-requests',
    loadComponent: () =>
      import(
        './downlink-requests/components/dt-downlink-requests/dt-downlink-requests.component'
      ).then((m) => m.DtDownlinkRequestsComponent),
  },
  {
    path: 'gaps',
    loadComponent: () =>
      import('./gaps/components/dt-gaps/dt-gaps.component').then(
        (m) => m.DtGapsComponent,
      ),
  },
];
